
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-10074 -3091 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 7346","transform":"translate(-11371.375 -3790)"}},[_c('circle',{attrs:{"cx":"8.5","cy":"8.5","r":"8.5","data-name":"Ellipse 903","transform":"translate(1297.375 699)","fill":"#35bd26"}}),_c('path',{attrs:{"d":"M1302.14 707.703l2.922 2.711 5.1-5.61","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"1.7"}})])])
          )
        }
      }
    